import SortAndFilterConfig from './SortAndFilterConfig';
import { FilterTypes } from '../workers/sortAndFilter';

export const defaultStatisticsFilters = (config: SortAndFilterConfig) => [
    {
        type: 'review' as FilterTypes['type'],
        keys: [5, 4, 3, 2, 1],
    },
    {
        type: 'price' as FilterTypes['type'],
        keys: config.filters.price?.brackets || [],
    },
];

export const defaultReviewFilterValues = [5, 4, 3, 2, 1];
